import { Field } from "formik";
import { Fragment } from "react";
import { PersonalSpaceFormFields } from "components/PanelWelcome/FormCreatePersonalSpace";
import { EuiFlexGroup, EuiText } from "@inscopix/ideas-eui";

interface CheckboxProps {
  fieldKey: keyof PersonalSpaceFormFields;
  fieldName: string;
}
export const Checkbox = ({ fieldKey, fieldName, ...props }: CheckboxProps) => {
  return (
    <Fragment key={fieldKey}>
      <EuiFlexGroup gutterSize="s">
        <Field
          {...props}
          id={fieldKey}
          name={fieldKey}
          title={fieldName}
          type="checkbox"
        />
        <label htmlFor={fieldKey}>
          <EuiText size="s">{fieldName}</EuiText>
        </label>
      </EuiFlexGroup>
    </Fragment>
  );
};
